// extracted by mini-css-extract-plugin
export default {"center_score":"game-card-center_center_score__UjTgF","score_divider":"game-card-center_score_divider__lXphl"};